function Best_part() {
  return (
    <div className="w-full h-[1100px] bg-[#f1fdf7] flex space-x-10 p-10">
      <div className="w-1/2 h-full flex-col p-20">
        <div>
            <span className="text-[#404145] text-6xl font-bold">The best part? Everything.</span>
        </div>
        <div className="w-full h-full py-10 flex-col space-y-10">
          <div>
            <h1 className="text-[#404145] text-4xl font-semibold">&#10004; Stick to the budget</h1>
            <p className="text-gray-400 text-3xl font-semibold leading-10 mt-6">Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore numquam possimus ratione debitis blanditiis iure inventor</p>
          </div>
          <div>
            <h1 className="text-[#404145] text-4xl font-semibold">&#10004; Stick to the budget</h1>
            <p className="text-gray-400 text-3xl font-semibold leading-10 mt-6">Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore numquam possimus ratione debitis blanditiis iure inventor</p>
          </div>
          <div>
            <h1 className="text-[#404145] text-4xl font-semibold">&#10004; Stick to the budget</h1>
            <p className="text-gray-400 text-3xl font-semibold leading-10 mt-6">Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore numquam possimus ratione debitis blanditiis iure inventor</p>
          </div>
          <div>
            <h1 className="text-[#404145] text-4xl font-semibold">&#10004; Stick to the budget</h1>
            <p className="text-gray-400 text-3xl font-semibold leading-10 mt-6">Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore numquam possimus ratione debitis blanditiis iure inventor</p>
          </div>
        </div>
      </div>
      <div className="w-1/2 h-full flex-col px-10 pt-20">
        <div className="w-full h-4/5 bg-black rounded-lg"></div>
      </div>
    </div>
  )
}

export default Best_part;